import {ISearchService} from './types';

/**
 * Import the appropriate search provider server here based on store configuration.
 *
 * We now use ShopifySearch, which talks to Shopify's native search endpoints
 * (influenced by the Search & Discovery app) instead of BoostCommerce.
 */

// import Service from './services/Klevu';
// import Service from './services/BoostCommerce';
import Service from './services/ShopifySearch';


const SearchService: ISearchService = {
  methods: {
    handleSearch: Service.methods.handleSearch,
    getFilters: Service.methods.getFilters,
    getProductResults: Service.methods.getProductResults,
    getCmsContent: Service.methods.getCmsContent,
  },
}

export default SearchService